import ErrorBoundary from './ErrorBoundary';
import ErrorView from './ErrorView';
/**
 * @deprecated
 */
var ErrorHandlingProvider = ErrorBoundary;
export { ErrorHandlingProvider, ErrorBoundary, ErrorView };
